import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const SelectInput = ({
  input,
  meta: {
    touched,
    error,
    warning
  },
  required,
  disabled,
  hideHints,
  placeholder,
  className,
  multiple,
  size,
  children,
  id
}) => (
  <div>
    <select
      { ...input }
      placeholder={ placeholder }
      className={ `${ className } ${ touched && error && 'is-error' }` }
      required={ required }
      disabled={ disabled }
      multiple={ multiple }
      size={ size }
      value={ input.value }
      id={ id }
    >
      { children }
    </select>
    {
      !hideHints && touched && (
        (error && <p className="form-input-hint">{ error }</p>)
        || (warning && <p className="form-input-hint">{ warning }</p>)
      )
    }
  </div>
);

SelectInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]),
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.any,
    warning: PropTypes.any
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hideHints: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  multiple: PropTypes.bool,
  size: PropTypes.number,
  id: PropTypes.string
};

SelectInput.defaultProps = {
  disabled: false,
  required: false,
  hideHints: false,
  placeholder: '',
  className: '',
  multiple: false,
  size: null,
  id: null
};
